import { useCallback, useContext } from 'react';
import { Or } from '../filterQueryFormat/logic/FilterLogicGroup';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { isCRMSearchFilters } from '../types/crmSearch/CrmSearchFilters';
import { OrderedMap } from 'immutable';
export const useQuickFiltersOnChangeHandler = () => {
  const {
    getIsUngated,
    props: {
      baseFilterFamily,
      onQuickFiltersChange,
      strategy
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const onChange = useCallback(newQuickFiltersInternalValue => {
    const newQuickFiltersInOrGroupInternalValue = newQuickFiltersInternalValue && newQuickFiltersInternalValue.conditions.size ? Or.ofRoot(newQuickFiltersInternalValue).set('conditions', OrderedMap([['0', newQuickFiltersInternalValue]])) : Or.of();
    const newQuickFiltersWithFilterFamilyInOrGroupInternalValue = newQuickFiltersInOrGroupInternalValue.set('filterFamily', baseFilterFamily);
    const newQuickFiltersQuery = strategy.serializer.toFormat(newQuickFiltersWithFilterFamilyInOrGroupInternalValue, getIsUngated, {
      useHoursFiltering: strategy.useHoursFiltering
    });
    if (typeof onQuickFiltersChange === 'function' && isCRMSearchFilters(newQuickFiltersQuery)) {
      onQuickFiltersChange(newQuickFiltersQuery);
    }
  }, [baseFilterFamily, strategy, onQuickFiltersChange, getIsUngated]);
  return onChange;
};